<h2 class="text-center p-10 text-3xl sm:text-4xl sm:p-28 italic">
  Página no encontrada o el usuario no tiene los permisos de acceso
</h2>
<div class="flex justify-center">
  <img
    src="assets/img/logo-error-bci.png"
    alt="Logo de error BCI"
    width="190"
  />
</div>
